import { PartialTranslation } from '../translations';

export const my: PartialTranslation = {
  newChat: 'စကားပြောခန်းအသစ်',
  search: 'ရှာရန်',
  user: 'အသုံးပြုသူ',
  settings: 'ဆက်တင်များ',
  language: 'ဘာသာစကား',
  getHelp: 'အကူအညီရယူရန်',
  viewAllPlans: 'အစီအစဉ်အားလုံးကြည့်ရန်',
  learnMore: 'နောက်ထပ်လေ့လာရန်',
  logOut: 'ထွက်ရန်',
  chooseLanguage: 'ဘာသာစကားရွေးချယ်ရန်',
  chooseYourPreferredLanguage: 'သင်နှစ်သက်သောဘာသာစကားကိုရွေးချယ်ပါ',
  searchLanguages: 'ဘာသာစကားများရှာရန်...',
  autoDetect: 'အလိုအလျောက်ရှာဖွေခြင်း',
  noLanguagesFound: 'ဘာသာစကားများမတွေ့ရပါ',
  askAnything: 'မှန်လုပ်ခွင့်မေးပါ',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'ကိုယ်ပိုင်',
  freePlan: 'အခမဲ့အစီအစဉ်',
  current: 'လက်ရှိ',
  close: 'ပိတ်ရန်',
  archive: 'မှတ်တမ်းသိမ်းဂဟုပ်',
  delete: 'ဖျက်ရန်',
  confirmDelete: 'ဤစကားပြောခန်းကိုဖျက်ရန်သေချာပါသလား။',
  confirmArchive: 'ဤစကားပြောခန်းကိုမှတ်တမ်းသိမ်းရန်သေချာပါသလား။',
  deleteCannotUndo: 'ဤလုပ်ဆောင်ချက်ကိုပြန်လည်ပြုပြင်၍မရပါ။',
  archiveCanFind: 'မှတ်တမ်းသိမ်းပြီးနောက်မှတ်တမ်းစာရင်းတွင်ရှာတွေ့နိုင်ပါသည်။',
  resources: 'အရင်းအမြစ်များ',
  addResource: 'အရင်းအမြစ်ထည့်ရန်',
  deleteResource: 'အရင်းအမြစ်ဖျက်ရန်',
  noMatchingResourcesFound: 'ကိုက်ညီသောအရင်းအမြစ်များမတွေ့ရပါ',
  noResourcesAvailable: 'အသုံးပြုနိုင်သောအရင်းအမြစ်များမရှိပါ',
  hideResources: 'အရင်းအမြစ်များဖုံးရန်',
  showResources: 'အရင်းအမြစ်များပြရန်',
  typeMessage: 'မက်ဆေ့ချ်ရိုက်ရန်...',
  thinkingOptions: 'စဥ်းစားမှုရွေးချယ်စရာများ',
  deleteFile: 'ဖိုင်ဖျက်ရန်',
  clearSelection: 'ရွေးချယ်မှုရှင်းလင်းရန်',
  addAttachment: 'ပူးတွဲမှုထည့်ရန်',
  sendMessage: 'မက်ဆေ့ချ်ပို့ရန်',
  deepInsight: 'နက်ရှိုင်းသောထိုးထွင်းသိမြင်မှု · မျက်နှာပြင်ခွဲခြမ်းစိတ်ဖြာမှု',
  deepInsightDesc: 'အဓိကအချက်များကိုလျင်မြန်စွာနားလည်ခြင်း',
  deepExploration: 'နက်ရှိုင်းသောရှာဖွေမှု · ပြည့်စုံသောခွဲခြမ်းစိတ်ဖြာမှု',
  deepExplorationDesc: 'ဘက်စုံနက်ရှိုင်းသောသုတေသန',
  deepDeconstruction: 'နက်ရှိုင်းသောတည်ဆောက်မှုဖျက်သိမ်းမှု · စနစ်တကျငြင်းခုံမှု',
  deepDeconstructionDesc: 'အလွှာလိုက်တစ်ဆင့်ခြင်းခွဲခြမ်းစိတ်ဖြာမှု',
  contractReview: 'စာချုပ်ပြန်လည်သုံးသပ်မှု · အန္တရာယ်ခွဲခြမ်းစိတ်ဖြာမှု',
  contractReviewDesc: 'ပုဒ်မများခွဲခြမ်းစိတ်ဖြာမှုနှင့်လိုက်နာမှုစစ်ဆေးမှု',
  textPolish: 'စာသားပြုပြောင်းမှု · ပရော်ဖက်ရှင်နယ်ဖော်ပြမှု',
  textPolishDesc: 'ဘာသာစကားအကောင်းဆုံးပြုမှုနှင့်ဖွဲ့စည်းပုံညှိညှိမှု',
  legalDocuments: 'ဥပဒေဆိုင်ရာစာရွက်စာတမ်းများ · စံပြပုံးတမ်း',
  legalDocumentsDesc: 'ပရော်ဖက်ရှင်နယ်ဥပဒေစာရွက်စာတမ်းရေးသားမှု',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'ဝင်ရောက်',
  register: 'စာရင်းသွင်း',
  welcomeBack: 'LawHelper မှ ကြိုဆိုပါသည်',
  loginSubtitle: 'သင့် AI ဥပဒေရေးရာ သုတေသန လက်ထောက်',
  continueWithGoogle: 'Google ဖြင့် ဆက်လက်',
  continueWithMicrosoft: 'Microsoft ဖြင့် ဆက်လက်',
  continueWithWeChat: 'WeChat ဖြင့် ဆက်လက်',
  orContinueWith: 'သို့မဟုတ် ဖြင့် ဆက်လက်',
  emailTab: 'အီးမေးလ်',
  phoneTab: 'ဖုန်း',
  emailPlaceholder: 'သင့်အီးမေးလ်ကို ရိုက်ထည့်ပါ',
  phonePlaceholder: 'ဖုန်းနံပါတ်ကို ရိုက်ထည့်ပါ',
  codePlaceholder: '၆ လုံးကုဒ်ကို ရိုက်ထည့်ပါ',
  sending: 'ပို့နေသည်...',
  verifying: 'အတည်ပြုနေသည်...',
  verify: 'အတည်ပြု',
  sendMagicLink: 'မှော်လင့်ခ်ပို့',
  getVerificationCode: 'ကုဒ်ရယူ',
  resendCode: 'ကုဒ်ပြန်ပို့',
  resendIn: 'ပြန်ပို့မည်',
  magicLinkSent: 'မှော်လင့်ခ်ကို သင့်အီးမေးလ်သို့ ပို့လိုက်ပါပြီ',
  magicLinkHint: 'သင့်အီးမေးလ်သို့ လုံခြုံသောလင့်ခ်ကို ပို့ပေးပါမည်',
  otpSent: 'အတည်ပြုကုဒ်ပို့လိုက်ပါပြီ',
  agreeToTerms: 'ဆက်လက်ခြင်းဖြင့် သင်သဘောတူသည်',
  privacyPolicy: 'ကိုယ်ရေးအချက်အလက်မူဝါဒ',
  termsOfService: 'ဝန်ဆောင်မှုစည်းမျဉ်းများ',
  and: 'နှင့်',
  privacyTitle: 'သင့်ကိုယ်ရေးအချက်အလက် အရေးကြီးပါသည်',
  privacyIntro: 'အကောင်းဆုံးအတွေ့အကြုံအတွက် ကွတ်ကီးများနှင့် အလားတူနည်းပညာများကို အသုံးပြုပါသည်။',
  essentialCookies: 'မရှိမဖြစ်ကွတ်ကီးများ',
  essentialDesc: 'ဝက်ဆိုက်အလုပ်လုပ်ရန် လိုအပ်သည်',
  analyticsCookies: 'ခွဲခြမ်းစိတ်ဖြာကွတ်ကီးများ',
  analyticsDesc: 'ဝန်ဆောင်မှုကို တိုးတက်စေရန် ကူညီသည်',
  marketingCookies: 'စျေးကွက်ရှာဖွေရေးကွတ်ကီးများ',
  marketingDesc: 'ပုဂ္ဂိုလ်ရေးအကြောင်းအရာအတွက် အသုံးပြုသည်',
  acceptAll: 'အားလုံးလက်ခံ',
  essentialOnly: 'မရှိမဖြစ်သာ',
  customize: 'စိတ်ကြိုက်ပြင်ဆင်',
  savePreferences: 'ရွေးချယ်မှုများသိမ်း',
  back: 'နောက်သို့',
  readPrivacyPolicy: 'ကျွန်ုပ်တို့၏ ကိုယ်ရေးအချက်အလက်မူဝါဒကို ဖတ်ရှုပါ',
  cookiePolicy: 'ကွတ်ကီးမူဝါဒ',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI သုံးသပ်ချက်',
  aiDraft: 'AI မူကြမ်း',
  smartAssistant: 'ပုံစံ',

  // 知识库搜索
  enableKnowledgeSearch: 'ရှာဖွေမှုဖွင့်',
  knowledgeSearchDesc: 'AI သည်သင့်စာရွက်စာတမ်းများတွင်ရှာဖွေသည်',
  clickToDisable: 'ပိတ်ရန်',
  clickToEnable: 'ဖွင့်ရန်',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'အမြန်အဖြေ',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'ဖျက်သိမ်း',
  library: 'စာကြည်းတိုက်',
  filterAll: 'အားလုံး',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'စဥ်းစားနေသည်...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'အထွေထွေ',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'အကြောင်း',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'စမတ် စာရွက် အကူညီ',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'အမှား',
  unknownError: 'Unknown error',
  file: 'ဖိုင်',
  loading: 'ဖွင့်နေသည်...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI ခွဲခြမ်းစိစ်',
};
